export default class ResourceLink {
  constructor(links) {
    if (links.length === 0) {
      return;
    }
    this.links = links;

    this.links.forEach(link => {
      this.clickHandler(link);
    });
  }

  clickHandler (link) {
    const href = this.getLink(link);
    if (!href) {
      return;
    }
    this.getLink(link).addEventListener('click', (event) => {
      event.preventDefault();
      link.classList.toggle('is-visible');
    })
  }

  getLink (link) {
    return link.getElementsByTagName('a').length > 0 ? link.getElementsByTagName('a')[0] : null;
  }
}
